import moment from "moment";

export function isObjEmpty(obj: Record<string | number, unknown>) {
  return Object.keys(obj).length === 0;
}

export const isNullish = (val: unknown): val is null | undefined =>
  val === null || val === undefined || val === "";

// Filter out nullish values from an object

export const filterNullishFromObject = <T extends object>(obj: T) =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => !isNullish(v)));

export const getDateOnly = (dob?: string) => {
  if (!dob) return undefined;

  return moment(dob).format("YYYY-MM-DD");
};

export const isNotASymbol = (char: string) => {
  return /^[a-zA-Z0-9]+$/.test(char);
};

export const getRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const formatDate = (
  dateType: Date | string,
  formatString = "h:mm A, MMM D",
) => {
  const date = moment(dateType);
  const now = moment();
  if (now.diff(date, "seconds") < 60) {
    return date.fromNow(true); // Output: just now or few seconds ago
  }
  const formattedDate = date.format(formatString);
  return formattedDate;
};

export const getProgress = (min: number, max: number, current: number) => {
  const progress = (current - min) / (max - min);

  return {
    progressPercent: Number((progress * 100).toFixed(2)),
    progress,
  };
};
